import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import NodeActionDialog from "./NodeActionDialog";
import { Switch } from "antd";
import DeleteIcon from "../../../images/LK_Delete";
import EditIcon from "../../../images/LK_Edit";
import SelectIcon from "../../../images/LK_Select";
import CloseIcon from "../../../images/LK_Close";

import EyeOpenIcon from "../../../images/LK_Eye_Open.png";
import { ThemeContext } from "../../Homepage";
import { useSelector } from "react-redux";
import Spinner from "./Spinner.jsx";
import CustomButton from "../../CommonComponents/CustomButton";
import ProtectedComponent from "../UserAccessManangement/ProtectedComponent.jsx";
import NOLOGO from '../../../images/nologo.png';
const OrganisationList = ({ selectedTreeNode, onAdd, onEdit, onDelete }) => {
  const node = selectedTreeNode
    ? JSON.parse(JSON.stringify(selectedTreeNode))
    : {};
  const [selectAddType, setSelectedAddType] = useState();
  const [dialogAction, setDialogAction] = useState("");
  const [currentChildNode, setCurrentChildNode] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const styles = {
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "auto",
    },
    divider: {
      margin: "8px 8px",
      background: "#3C3C3C;",
    },
    cardText: {
      marginBottom: 0,
      padding: "4px 0px",
    },
    typographyLabel: {
      fontSize: 14,
      fontWeight: 400,
      marginTop: -2,
    },
    typographyValue: {
      fontSize: 21,
      fontWeight: 400,
    },
  };

  const childType = node.children?.[0]?.type || "";

  const openDialog = (action, childNode = null) => {
    setDialogAction(action);
    setCurrentChildNode(childNode);
    setDialogOpen(true);
  };
  const closeDialog = () => {
    setDialogOpen(false);
    setCurrentChildNode(null);
  };

  const CardText = ({ label, value }) => (
    <Box className="cardtext">
      <Typography sx={{ fontSize: 14, fontWeight: 400 }}>{label}</Typography>
      <Typography sx={{ fontSize: 15, fontWeight: 400 }}>{value}</Typography>
    </Box>
  );

const filteredChildren = Array.isArray(node?.children)
  ? node.children.filter((child) => {
      const query = searchQuery?.toLowerCase();
      return (
        child?.Label?.toLowerCase()?.includes(query) ||
        child?.Organizationname?.toLowerCase()?.includes(query) ||
        child?.Projectname?.toLowerCase()?.includes(query) ||
        child?.Organizationdetails?.Pin?.toLowerCase()?.includes(query) ||
        child?.Organizationdetails?.Location?.toLowerCase()?.includes(query) ||
        child?.Organizationdetails?.State?.toLowerCase()?.includes(query) ||
        child?.Projectdetails?.Pin?.toLowerCase()?.includes(query) ||
        child?.Projectdetails?.Location?.toLowerCase()?.includes(query) ||
        child?.Projectdetails?.State?.toLowerCase()?.includes(query)
      );
    })
  : [];
  const handleAdd = (newnode) => {
    onAdd(node.Organizationid, newnode);
    closeDialog();
  };

    const handleEdit = (updatedNode) => {
      onEdit(currentChildNode.id, updatedNode);
  };

  const handleDelete = (projectId) => {
    onDelete(currentChildNode);

    closeDialog();
  };
  const { theme } = useContext(ThemeContext);
  const orgtree = useSelector((state) => state.configdata.organizationdatatree);
  const hasValues = Object.keys(node).length > 0;
  const {PermissionsArray:usrPrmns} = useSelector((state) => state.logindata.userdetails);
  const orgAccess  = usrPrmns && usrPrmns.includes("OGCR03") || usrPrmns.includes("SBCR04");
  return (
    <Box
      style={{
        backgroundColor: theme === "dark" ? "#252525" : "white",
      }}
    >
      {hasValues ? (
        <>
          <Box>
            {node && node?.label !== "Organization List" && (
              <Box
                sx={{
                  // padding: "4px 4px 4px 0px",
                  boxSizing: "border-box",
                  // marginTop: "12px",
                  height: "100px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "auto",
                    gap: "4px",
                    marginTop: 0,
                    backgroundColor: "var(--SecondaryBackground)",
                    color: "var(--PrimaryText)",
                    borderRadius: "0px 0px 0px 0px",
                    border: "1.5px solid var(--HighlightedText_Stroke)",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={styles.container}>
                    <CardText
                      label="Name"
                      value={node?.Organizationname || node?.Projectname}
                    />
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={styles.divider}
                    />
                     <CardText label="Type" value={node?.Type && node?.Type.charAt(0).toUpperCase() + 
                    node?.Type.slice(1) } />
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={styles.divider}
                    />
                    <CardText
                      label="Location"
                      value={
                        node?.Organizationdetails?.Location ||
                        node?.Projectdetails?.Location ||
                        "N/A"
                      }
                    />
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={styles.divider}
                    />
                    <CardText
                      label="Latitude"
                      value={
                        node?.Organizationdetails?.Latitude ||
                        node?.Projectdetails?.Latitude ||
                        "N/A"
                      }
                    />
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={styles.divider}
                    />
                    <CardText
                      label="Longitude"
                      value={
                        node?.Organizationdetails?.Longitude ||
                        node?.Projectdetails?.Longitude ||
                        "N/A"
                      }
                    />
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={styles.divider}
                    />
                    <CardText
                      label="Country"
                      value={
                        node?.Organizationdetails?.Country ||
                        node?.Projectdetails?.Country ||
                        "NA"
                      }
                    />
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={styles.divider}
                    />
                    <CardText
                      label="State"
                      value={
                        node?.Organizationdetails?.State ||
                        node?.Projectdetails?.State ||
                        "NA"
                      }
                    />
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={styles.divider}
                    />
                    <CardText
                      label="Pin"
                      value={
                        node?.Organizationdetails?.Pin ||
                        node?.Projectdetails?.Pin ||
                        "NA"
                      }
                    />
                  </Box>
                </Box>
              </Box>
            )}
          </Box>

          {node?.Type?.toLowerCase() !== "project" && (
            <Box
              style={{
                backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
                padding: "5px",
                margin: "10px",
              }}
            >
              <Box
                sx={{
                  mt: "15px",
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#008CD7",
                    fontWeight: "bold",
                    ml: "16px",
                    backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
                  }}
                >
                  {selectedTreeNode.id == "root" && "Organizations"}
                  {selectedTreeNode.id !== "root" &&
                    "Sub-Organizations and Projects"}
                </Typography>
                <Box>
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      width: "350px",
                      height: "40px",
                      backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
                      // borderRadius: "4px",
                      color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                      border: "none",
                      borderBottom: "1px solid #008CD7",
                      padding: "0px 5px",
                      marginRight: "20px",
                      outline: "none",
                    }}
                  />
                    {orgAccess             
             && (<button
                    style={{
                      width: "125px",
                      height: "35px",
                      fontSize: "18px",
                      backgroundColor: "rgb(0, 92, 142)",
                      color: "rgb(255, 255, 255)",
                      cursor: "pointer",
                      border: "none",
                      borderRadius: "25px",
                    }}
                    onClick={() =>
                      openDialog("add", {
                        type:
                          node.children?.length === 0
                            ? selectAddType
                            : childType,
                      })
                    }
                  >
                    Create
                  </button>
                )}
                </Box>
              </Box>
              <Box
                sx={{
                  mt: "15px",
                  //  border: "1.5px solid var(--HighlightedText_Stroke)",
                  backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
                  color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                }}
              >
                <TableContainer
                  // sx={{
                  //   maxHeight: "400px",
                  //   overflow: "auto",
                  // }}
                  component={Paper}
                  style={{
                    backgroundColor: theme === "dark" ? "#252525" : "#F0EFEF",
                    maxHeight: "calc(100vh - 460px)",
                    // overflowY: "scroll",
                    // maxHeight: "500px",
                    maxHeight: "390px",
                    boxShadow: "none",
                    background: "#f0efef",
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                            backgroundColor:
                              theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "19px",
                            textAlign: "left",
                          }}
                        >
                          Logo
                        </TableCell>
                        <TableCell
                          sx={{
                            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                            backgroundColor:
                              theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "19px",
                            textAlign: "left",
                          }}
                        >
                          Name
                        </TableCell>
                        <TableCell
                          sx={{
                            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                            backgroundColor:
                              theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "19px",
                            textAlign: "left",
                          }}
                        >
                          Type
                        </TableCell>
                        <TableCell
                          sx={{
                            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                            backgroundColor:
                              theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "19px",
                            textAlign: "left",
                          }}
                        >
                          Country
                        </TableCell>
                        <TableCell
                          sx={{
                            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                            backgroundColor:
                              theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "19px",
                            textAlign: "left",
                          }}
                        >
                          Location
                        </TableCell>
                        <TableCell
                          sx={{
                            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                            backgroundColor:
                              theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "19px",
                            textAlign: "left",
                          }}
                        >
                          State
                        </TableCell>
                        <TableCell
                          sx={{
                            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                            backgroundColor:
                              theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "19px",
                            textAlign: "left",
                          }}
                        >
                          Pin
                        </TableCell>
                         { orgAccess && 
                  <TableCell
                          sx={{
                            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                            backgroundColor:
                              theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "19px",
                            textAlign: "left",
                          }}
                        >
                          Actions
                        </TableCell>
                      }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredChildren && filteredChildren.length > 0 ? (
                        filteredChildren.map((childNode) => childNode && (
                          <TableRow key={childNode.id}>
                            <TableCell
                              sx={{
                                backgroundColor:
                                  theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "19px",
                                textAlign: "left",
                                maxWidth: "150px",
                              }}
                            >
                             {childNode && childNode.Logo && childNode.Logo.base64 ? (
                                <img
                                  src={childNode.Logo.base64}
                                  alt="Logo"
                                  style={{
                                    height: "50px",
                                    width: "50px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <Typography
                                  sx={{
                                    color:
                                      theme === "dark" ? "#C1C1C1" : "#3A4452",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                  }}
                                >
                                <img src={NOLOGO} alt="Default Logo" style={{height:"40px",width:"40px",borderRadius: "25px"}}/>
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell
                              sx={{
                                backgroundColor:
                                  theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "19px",
                                textAlign: "left",
                                maxWidth: "150px",
                              }}
                            >
                           {childNode &&
                            (childNode.Label ||
                              childNode.Organizationname ||
                              childNode?.Projectname)}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                                backgroundColor:
                                  theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                                fontFamily: "Roboto",
                                fontSize: "16px",
                                fontSize: "14px",
                                fontWeight: 400,
                                textAlign: "left",
                                maxWidth: "150px",
                              }}
                            >
                              {childNode.Type
                                ? childNode.Type.charAt(0).toUpperCase() +
                                  childNode.Type.slice(1)
                                : "N/A"}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                                backgroundColor:
                                  theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "19px",
                                textAlign: "left",
                                maxWidth: "150px",
                              }}
                            >
                              {childNode?.Organizationdetails?.Country ||
                                childNode?.Projectdetails?.Country ||
                                "N/A"}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                                backgroundColor:
                                  theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "19px",
                                textAlign: "left",
                                maxWidth: "150px",
                              }}
                            >
                              {childNode?.Organizationdetails?.Location ||
                                childNode?.Projectdetails?.Location ||
                                "N/A"}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                                backgroundColor:
                                  theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "19px",
                                textAlign: "left",
                                maxWidth: "150px",
                              }}
                            >
                              {childNode?.Organizationdetails?.State ||
                                childNode?.Projectdetails?.State ||
                                "N/A"}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                                backgroundColor:
                                  theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "19px",
                                textAlign: "left",
                                maxWidth: "150px",
                              }}
                            >
                              {childNode?.Organizationdetails?.Pin ||
                                childNode?.Projectdetails?.Pin ||
                                "N/A"}
                            </TableCell>
                          { orgAccess &&  <TableCell
                              sx={{
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                                backgroundColor:
                                  theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "19px",
                                textAlign: "left",
                                maxWidth: "150px",
                              }}
                            >
                              <Tooltip title="View" arrow>
                                <span
                                  onClick={() => openDialog("view", childNode)}
                                  style={{
                                    marginRight: "2px",
                                    padding: "4px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={EyeOpenIcon}
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      paddingTop: "4px",
                                      marginRight: "4px",
                                    }}
                                    alt="View"
                                  />
                                </span>
                              </Tooltip>
                              <Tooltip title="Edit" arrow>
                                <span
                                  onClick={() => openDialog("edit", childNode)}
                                  style={{
                                    marginRight: "2px",
                                    padding: "4px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <EditIcon
                                    color="var(--LK_BrandBlue)"
                                    width={"18px"}
                                    height={"18px"}
                                  />
                                </span>
                              </Tooltip>
                              <Tooltip title="Delete" arrow>
                                <span
                                  onClick={() =>
                                    openDialog("delete", childNode)
                                  }
                                  style={{
                                    marginRight: "2px",
                                    padding: "4px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <DeleteIcon
                                    color="var(--LK_BrandBlue)"
                                    width={"18px"}
                                    height={"18px"}
                                  />
                                </span>
                              </Tooltip>
                            </TableCell>
                            }
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={8}
                            align="center"
                            sx={{
                              backgroundColor:
                                theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                            }}
                          >
                            <Typography
                              variant="body2"
                              align="center"
                              sx={{
                                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                              }}
                            >
                              No matching nodes found.
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          )}
        </>
      ) : (
        <p
          style={{
            display: "flex",
            justifyContent: "center",
             paddingTop: "30%"
          }}
        >
          Select a node to view details
        </p>
      )}

      <NodeActionDialog
        open={dialogOpen}
        actionType={dialogAction}
        node={currentChildNode}
        onClose={closeDialog}
        onSave={dialogAction === "add" ? handleAdd : handleEdit}
        onDeleteConfirm={handleDelete}
        selectedTreeNode={selectedTreeNode}
      />
    </Box>
  );
};

export default OrganisationList;
